__turbopack_context__.v({
  "barSearch": "app-shell-module__uk8rSG__barSearch",
  "brand": "app-shell-module__uk8rSG__brand",
  "collapse": "app-shell-module__uk8rSG__collapse",
  "collapseIcon": "app-shell-module__uk8rSG__collapseIcon",
  "collapseLabel": "app-shell-module__uk8rSG__collapseLabel",
  "content": "app-shell-module__uk8rSG__content",
  "contentScroll": "app-shell-module__uk8rSG__contentScroll",
  "mainCol": "app-shell-module__uk8rSG__mainCol",
  "mark": "app-shell-module__uk8rSG__mark",
  "markDot": "app-shell-module__uk8rSG__markDot",
  "nav": "app-shell-module__uk8rSG__nav",
  "navBadge": "app-shell-module__uk8rSG__navBadge",
  "navDot": "app-shell-module__uk8rSG__navDot",
  "navIcon": "app-shell-module__uk8rSG__navIcon",
  "navItem": "app-shell-module__uk8rSG__navItem",
  "navLabel": "app-shell-module__uk8rSG__navLabel",
  "navMore": "app-shell-module__uk8rSG__navMore",
  "navSection": "app-shell-module__uk8rSG__navSection",
  "navSectionRow": "app-shell-module__uk8rSG__navSectionRow",
  "sectionAction": "app-shell-module__uk8rSG__sectionAction",
  "sectionActions": "app-shell-module__uk8rSG__sectionActions",
  "shell": "app-shell-module__uk8rSG__shell",
  "sidebar": "app-shell-module__uk8rSG__sidebar",
  "topRight": "app-shell-module__uk8rSG__topRight",
  "topRightSlot": "app-shell-module__uk8rSG__topRightSlot",
  "topbar": "app-shell-module__uk8rSG__topbar",
  "topbarDefault": "app-shell-module__uk8rSG__topbarDefault",
  "topbarPeekSlot": "app-shell-module__uk8rSG__topbarPeekSlot",
  "topbarSlot": "app-shell-module__uk8rSG__topbarSlot",
  "viewRow": "app-shell-module__uk8rSG__viewRow",
  "viewStar": "app-shell-module__uk8rSG__viewStar",
  "wordmark": "app-shell-module__uk8rSG__wordmark",
});
